import React, { memo, useEffect, useState } from 'react';
import { Form, Input, InputNumber, Select, Button, Tabs, DatePicker, notification, Row, Col, Card } from 'antd';
import './startLearning.css';
import { UserOutlined, KeyOutlined, MailOutlined, MobileOutlined, TeamOutlined, QuestionCircleOutlined, LockOutlined } from '@ant-design/icons';
import { action } from '../../store';
import { useHistory, Link, withRouter } from 'react-router-dom';
import { Checkbox } from 'antd';

import { getCookie } from '../../utils/session';
import {
  registerUser,
  changePassword,
  updatePassword,
  loginUser,
  resetAllStatus,
  validatePasswordToken
} from '../../actions/Authentication-action';
// import { validatePasswordToken } from '../../saga/AuthenticationService';
// import history from '../../store/history';
import moment from 'moment';
notification.config({
  duration: 30
})
const { TabPane } = Tabs;
const leftInput = { display: 'inline-block', width: 'calc(50% - 8px)' };
const rightInput = { display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' };
const fullInput = { display: 'inline-block', width: 'calc(100% - 8px)' }
const hundredWidth = { display: 'inline-block', width: '100%' }
const { Option } = Select;
const {TextArea} = Input

const StartLearning = ({ guest, keyNumber, match: { params: { randomKey, email } }, isEmailVerified }) => {
  const userID = getCookie('user_id');
  let history = useHistory();
  const { loading } = guest;
  // const disabledDates = moment()
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().add('years', -15);
  }
  notification.config({
    duration: 20
  })
  useEffect(() => {
    if (guest && guest.isUserRegistered) {
      notification["success"]({
        message: "Registered Successfully & Please check your Mail to Verify"
      });
      // action(resetAllStatus());
    } else if (guest && guest.isUserLogin) {
      notification["success"]({
        message: "Login Successfully"
      });
      history.push("/user")
      // action(resetAllStatus());
    } else if (guest && guest.isUserTokenValid) {
      notification["success"]({
        message: "Token Sent Successfully"
      });
    } else if (guest && guest.isPasswordUpdated) {
      notification["success"]({
        message: "Password Updated Successfully"
      });
    }
    action(resetAllStatus());
  }, [guest.isUserRegistered, guest.isUserLogin, guest.isUserTokenValid, guest.isPasswordUpdated])

  useEffect(() => {
    if (isEmailVerified) {
      notification["success"]({
        message: "Email Verified Successfully"
      });
    }
  }, [isEmailVerified]);
  useEffect(() => {
    if (randomKey) {
      action(
        validatePasswordToken({
          email: email,
          token: randomKey
        })
      );
    }
  }, [])

  useEffect(() => {
    if (guest.type === "error") {
      notification["error"]({
        message: guest.message
      });
      history.push("/start-learning/login")
    }

    if (guest.type === "success") {
      notification["success"]({
        message: guest.message
      });
    }
  }, [guest.message]);

  const onLoginFinish = values => {
    action(loginUser(values));
    // console.log('Success:', values);
  };

  const onLoginFinishFailed = errorInfo => {
    // console.log('Failed:', errorInfo);
  };

  const onRegisterFinish = values => {
    values.monthly_family_income = parseInt(values.monthly_family_income);
    values.dob = values.dob.format("YYYY-MM-DD");
    action(registerUser(values));
  };

  const onRegisterFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const updateStateUrl = (key) => {
    if (key === "1") history.push("/start-learning/login")
    else history.push("/start-learning/register")
  }

  const goToDashboard = () => {
    history.push('/user');
    history.go();
    history.go();
  }

  const onChangePasswordFinish = (values) => {
    action(changePassword(values));
  }

  const onChangePasswordFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  }

  const onUpdatePasswordFinish = (values) => {
    action(updatePassword({
      email: email,
      token: randomKey,
      pasword: values.password
    }));
  }

  const onUpdatePasswordFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  }

  return (
    <div className="card-container">
      {
        !!userID ? (
          <Row align="middle">
            <Col span={24} style={{ textAlign: 'center' }}>
              {/* <Link to="/user" type="primary">Go To Dashboard</Link> */}
              <Button onClick={goToDashboard} type="primary">Go To Dashboard</Button>
            </Col>
          </Row>
        ) : (
          (keyNumber === "3") ? (
            <Row>
              <Col span={24} >
                <Card style={{ maxWidth: "450px", margin: "0px auto" }}>
                  <Form
                    name="forgrtPassword"
                    onFinish={onChangePasswordFinish}
                    onFinishFailed={onChangePasswordFailed}
                  >
                    <h3 style={{ textAlign: "center", marginBottom: "15px", marginTop: "-10px" }} >Reset Password</h3>
                    <Form.Item
                      name="email"
                      rules={[{ type: "email", required: true, message: 'Please input your email!' }]}
                    >
                      <Input prefix={<UserOutlined />} placeholder="Enter Email" />
                    </Form.Item>

                    <Form.Item className="text-center">
                      <Button type="primary" htmlType="submit" className="submit-cta" loading={loading}>
                        Submit
                        </Button>
                        &nbsp; &nbsp;
                        <Link to="/start-learning/login">
                        <Button className="submit-cta">
                          Back
                          </Button>
                      </Link>
                    </Form.Item>
                  </Form>
                </Card>

              </Col>
            </Row>
          ) : (
            (keyNumber === "4" && guest.isTokenValid) ? (
              <Row>
                <Col span={24}>
                  <Card style={{ maxWidth: "450px", margin: "0px auto" }}>
                    <h3 style={{ textAlign: "center", marginBottom: "15px", marginTop: "-10px" }} >Reset Password</h3>
                    <Form
                      name="forgrtPassword"
                      onFinish={onUpdatePasswordFinish}
                      onFinishFailed={onUpdatePasswordFailed}
                    >
                      <Form.Item
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your password!',
                          },
                        ]}
                        hasFeedback
                      >
                        <Input.Password placeholder="Enter New Password" />
                      </Form.Item>

                      <Form.Item
                        name="confirmPassword"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: 'Please confirm your password!',
                          },
                          ({ getFieldValue }) => ({
                            validator(rule, value) {
                              if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                              }

                              return Promise.reject('The two passwords that you entered do not match!');
                            },
                          }),
                        ]}
                      >
                        <Input.Password placeholder="Re-Enter New Password" />
                      </Form.Item>

                      <Form.Item className="text-center">
                        <Button type="primary" htmlType="submit" className="submit-cta wd-140" loading={loading}>
                          Submit
                                                        </Button>
                                                        &nbsp; &nbsp;
                                                        <Link to="/start-learning/login">
                          <Button className="submit-cta wd-140">
                            Back
                                                            </Button>
                        </Link>

                      </Form.Item>
                    </Form>
                  </Card>

                </Col>
              </Row>
            ) : (
              <Tabs type="card" activeKey={!guest.isTokenValid ? keyNumber : "1"} onChange={updateStateUrl}>
                <TabPane tab="Sign In" className="login-tab" key="1">
                  <Form
                    name="login"
                    onFinish={onLoginFinish}
                    onFinishFailed={onLoginFinishFailed}
                  >
                    <Form.Item
                      name="email"
                      rules={[{ required: true, type: "email", message: 'Please enter your valid email!' }]}
                    >
                      <Input prefix={<UserOutlined />} placeholder="Email Address" />
                    </Form.Item>

                    <Form.Item
                      name="password"
                      rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                      <Input.Password prefix={<KeyOutlined />} placeholder="Password" />
                    </Form.Item>

                    <Form.Item>
                      <Link to="/start-learning/forgot-password" className="login-form-forgot">
                        Forgot password
                                                        </Link>
                    </Form.Item>

                    <Form.Item className="text-center">
                      <Button type="primary" htmlType="submit" className="submit-cta" loading={loading}>
                        Log In
                                                        </Button>
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane tab="Register Now" key="2">
                  <Form
                    name="register"
                    onFinish={onRegisterFinish}
                    onFinishFailed={onRegisterFailed}
                  >
                    <Form.Item>
                      <Input.Group compact>
                            <Form.Item
                                name="username"
                                rules={[{ required: true, message: 'Please input your first name!' }]}
                                style={leftInput}
                            >
                                <Input placeholder="First Name" prefix={<UserOutlined />} />
                            </Form.Item>
                            <Form.Item
                                name="usernamelast"
                                rules={[{ required: true, message: 'Please input your last name!' }]}
                                style={rightInput}
                            >
                                <Input placeholder="Last Name" prefix={<UserOutlined />} />
                            </Form.Item>
                        </Input.Group>

                        <Input.Group >
                          <Form.Item
                            name="email"
                            rules={[{ type: "email", required: true, message: 'Please input your email address!' }]}
                            style={fullInput}
                          >
                            <Input prefix={<MailOutlined />} placeholder="Email Address" />
                          </Form.Item>
                          </Input.Group>
                          <Input.Group>
                        <Form.Item
                          name="password"
                          rules={[{ required: true, message: 'Please input your password!' }]}
                          style={fullInput}
                        >
                          <Input.Password prefix={<KeyOutlined />} placeholder="Password" />
                        </Form.Item>
                        </Input.Group>
                        <Input.Group compact>
                            <Form.Item
                                name="phone"
                                rules={[{  message: 'Please input your phone number!' }]}
                                style={leftInput}
                            >
                                <Input prefix={<MobileOutlined />} placeholder="Phone Number" />
                            </Form.Item>
                            <Form.Item
                                name="dob"
                                rules={[{ required: true, message: 'Please input your date of birth!' }]}
                                style={rightInput}
                            >
                                <DatePicker placeholder="Date of Birth" maxDate={moment().subtract(18, "years")} />
                            </Form.Item>
                        </Input.Group>
                        <Input.Group compact>

                            <Form.Item
                                name="gender"
                                rules={[{ required: true, message: 'Please select your gender!' }]}
                                style={leftInput}
                            >
                                <Select placeholder="Select Gender">
                                    <Option value="Female">Female</Option>
                                    <Option value="Male">Male</Option>
                                    <Option value="Third Gender">Third Gender</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="social_identity"
                                rules={[{ required: true, message: 'Please input your social identity!' }]}
                                style={rightInput}
                            >
                                <Input placeholder="Social Identity (race, ethnicity, etc" />
                            </Form.Item>
                        </Input.Group>
                        <Input.Group>
                            <Form.Item
                                name="mailing_address"
                                rules={[{ required: true, message: 'Please enter the mailing address' }]}
                                style={fullInput}
                            >
                                <TextArea rows={4} placeholder="Mailing Address" />

                            </Form.Item>
                        </Input.Group>
                        <Input.Group compact>
                           
                                <p style={{textAlign:"justify"}} >I understand that my participation is voluntary and I have my parents/legal guardians consent to participate in the virtual camp. I also understand that this is a safe and inclusive event for diverse young leaders and I promise to respect and practice diversity and inclusion while I participate. I understand that I will have the voluntary opportunity to share the creative works I produce during the camp with TYCL International for documentation of the camp and/or exhibition or publication. <span style={{color:"red"}}>*</span></p>
                        </Input.Group>
                    
                    </Form.Item>

                    <Form.Item className="text-center">
                      <Button type="primary" htmlType="submit" className="submit-cta" >
                        Create Account
                            </Button>
                    </Form.Item>
                  </Form>
                </TabPane>
              </Tabs>
            )
          )
        )
      }

    </div>
  )
}

export default memo(withRouter(StartLearning));